import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";

@Component({
    selector: "app-filter-list-bills",
    templateUrl: "./filter-list-bills.component.html",
    styleUrls: ["./filter-list-bills.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FilterListBillsComponent implements OnInit {
  public formFilterListBills: UntypedFormGroup = null;
  @Output() submitFilters = new EventEmitter<void>();

  constructor(private _fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.initializeformFilterBills();
  }

  /**
   * Handle the filter list bills form field
   * @returns
   */
  public onFilterListBills(): UntypedFormGroup {
    if (this.formFilterListBills) {
      return this.formFilterListBills;
    }
  }

  /**
   * Handle the initialization of the list bills filter form field
   */
  private initializeformFilterBills(): void {
    this.formFilterListBills = this._fb.group({
      billNumber: [""],
      billDate: [""],

      fromDate: [""],
      toDate: [""],
    });
  }
}
